import styled from 'styled-components';

import {
  PlayerSearchViewAttributes,
  PriceDisplay,
} from '@sorare/core/src/lib/playerSearchView';
import { floorPricesAttributes } from '@sorare/core/src/lib/scouting-center';

import { DropdownFilter } from '#src/searchCommonPlayer/DropdownFilter/index.tsx';
import {
  BackendRefineFloorPrices,
  RefineFloorPrices,
} from '#src/searchCommonPlayer/RangeSlider/index.tsx';
import { useManagePlayerSearchView } from '#src/searchCommonPlayer/StatsManager/useManagePlayerSearchView.ts';

const VisibleWrapper = styled.div`
  display: none;
  &[data-visible] {
    display: block;
  }
`;

const FloorPricesWidgets = RefineFloorPrices(false);
const BackendFloorPricesWidgets = BackendRefineFloorPrices(false);

export const FloorPricesDropdownFilter = () => {
  const { statsManager } = useManagePlayerSearchView();
  const currentPriceFilter = floorPricesAttributes(
    statsManager[PlayerSearchViewAttributes.RARITY],
    statsManager[PlayerSearchViewAttributes.SEASONALITY]
  );
  const showsFloorPrices =
    statsManager[PlayerSearchViewAttributes.PRICE_DISPLAY] ===
    PriceDisplay.FLOOR_PRICE;

  return FloorPricesWidgets.map(widget => {
    const visible = showsFloorPrices && currentPriceFilter === widget.key;

    return (
      <VisibleWrapper key={widget.key} data-visible={visible || undefined}>
        <DropdownFilter widget={widget} visible={visible} />
      </VisibleWrapper>
    );
  });
};

export const BackendFloorPricesDropdownFilter = () => {
  const { statsManager } = useManagePlayerSearchView();
  const currentPriceFilter = floorPricesAttributes(
    statsManager[PlayerSearchViewAttributes.RARITY],
    statsManager[PlayerSearchViewAttributes.SEASONALITY]
  );
  const showsFloorPrices =
    statsManager[PlayerSearchViewAttributes.PRICE_DISPLAY] ===
    PriceDisplay.FLOOR_PRICE;

  return BackendFloorPricesWidgets.map(widget => {
    const visible = showsFloorPrices && currentPriceFilter === widget.key;

    return (
      <VisibleWrapper key={widget.key} data-visible={visible || undefined}>
        <DropdownFilter widget={widget} visible={visible} />
      </VisibleWrapper>
    );
  });
};
